import logo from "../../assets/images/logos/Icon_Opaline.png"

export default function LogoIconOpaline({ width = 100, height = 100 }) {
    return (
        <img src={logo} width={width} height={height} alt="Icone du logo de La Maison Opaline" />
    )
};